import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "_mb-6" }
const _hoisted_2 = {
  key: 0,
  class: "gfu-field has-error"
}
const _hoisted_3 = {
  class: "gfu-field__error",
  "data-qa": "payment-method-required"
}
const _hoisted_4 = { ref: "adyenRedirectAction" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_notificator = _resolveComponent("base-notificator")
  const _component_adyen_payment_method_option = _resolveComponent("adyen-payment-method-option")
  const _component_adyen_payment_method_group = _resolveComponent("adyen-payment-method-group")
  const _component_terms_of_service_checkbox_field = _resolveComponent("terms-of-service-checkbox-field")
  const _component_right_of_withdrawal_consent_checkbox_field = _resolveComponent("right-of-withdrawal-consent-checkbox-field")
  const _component_adyen_payment_modal = _resolveComponent("adyen-payment-modal")
  const _component_progress_overlay = _resolveComponent("progress-overlay")

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.notifications, (item, index) => {
      return (_openBlock(), _createBlock(_component_base_notificator, {
        key: index,
        "can-close": false,
        class: "_my-2",
        message: item.message,
        type: item.type
      }, null, 8 /* PROPS */, ["message", "type"]))
    }), 128 /* KEYED_FRAGMENT */)),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.groupedAvailablePaymentMethodItems, (paymentGroup) => {
        return (_openBlock(), _createBlock(_component_adyen_payment_method_group, {
          key: paymentGroup.title,
          title: paymentGroup.title,
          "collapsed-title": paymentGroup.collapsedTitle,
          "is-title-visible": paymentGroup.isTitleVisible,
          "is-collapsible": paymentGroup.isCollapsible,
          "is-collapsed": paymentGroup.isCollapsed,
          onToggle: $event => ($options.toggleGroupVisibility(paymentGroup.sectionType)),
          "data-qa": $options.getGroupDataQa(paymentGroup.sectionType)
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paymentGroup.paymentMethods, (paymentMethod) => {
              return (_openBlock(), _createBlock(_component_adyen_payment_method_option, {
                key: paymentMethod.paymentDataSource,
                "payment-method": paymentMethod,
                "is-selected": paymentMethod.isSelected,
                onSelect: $event => ($options.onPaymentMethodSelect(paymentMethod.paymentDataSource))
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(paymentMethod.form), _mergeProps({ ref_for: true }, $options.getPaymentMethodProps(paymentMethod), {
                    ref_for: true,
                    ref: "paymentMethodForm",
                    class: "_pa-3",
                    onFormDetailsChanged: $options.onPaymentMethodFormChange
                  }), null, 16 /* FULL_PROPS */, ["onFormDetailsChanged"]))
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["payment-method", "is-selected", "onSelect"]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["title", "collapsed-title", "is-title-visible", "is-collapsible", "is-collapsed", "onToggle", "data-qa"]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    (!$options.isPaymentMethodSelected && !$options.isProceedPaymentBlocked)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.Resources.Checkout.InvalidPaymentOptionErrorMessage), 1 /* TEXT */)
        ]))
      : _createCommentVNode("v-if", true),
    _renderSlot(_ctx.$slots, "content"),
    ($props.requireAcceptTos && !$options.isProceedPaymentBlocked)
      ? (_openBlock(), _createBlock(_component_terms_of_service_checkbox_field, {
          key: 1,
          modelValue: $data.model.termsAccepted,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.model.termsAccepted) = $event)),
          class: "_mt-6",
          name: "model.termsAccepted"
        }, null, 8 /* PROPS */, ["modelValue"]))
      : _createCommentVNode("v-if", true),
    ($props.requireWithdrawalConsent)
      ? (_openBlock(), _createBlock(_component_right_of_withdrawal_consent_checkbox_field, {
          key: 2,
          modelValue: $data.model.isRightOfWithdrawalConsentAccepted,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.model.isRightOfWithdrawalConsentAccepted) = $event)),
          name: "model.isRightOfWithdrawalConsentAccepted"
        }, null, 8 /* PROPS */, ["modelValue"]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_4, null, 512 /* NEED_PATCH */),
    _renderSlot(_ctx.$slots, "actions", _normalizeProps(_guardReactiveProps({
                onSubmit: $options.onSubmit,
                isProceedPaymentBlocked: $options.isProceedPaymentBlocked,
                paymentMethodErrorMessage: $options.paymentMethodErrorMessage,
                isProcessing: _ctx.isProcessing,
                grantOrderAccess: $setup.paymentSubmission.grantOrderAccess,
            }))),
    ($data.isAdyenPaymentModalVisible)
      ? (_openBlock(), _createBlock(_component_adyen_payment_modal, {
          key: 3,
          "project-id": $props.projectId,
          "is-modal-visible": $data.isAdyenPaymentModalVisible,
          "is-instant": $options.isInstantPaymentSelected,
          "order-code": $options.effectiveOrderCode,
          "provider-payment-id": $data.currentProviderPaymentID,
          "checkout-mode": $options.effectiveCheckoutMode,
          "payment-data-source": $options.selectedPaymentMethod,
          "store-credit-card": $options.shouldStoreCreditCard,
          "payment-type": $data.model.paymentType,
          "payment-action": $data.paymentActionData,
          "available-payment-methods": $props.availablePaymentMethods,
          onClose: $options.onAdyenPaymentModalClose,
          onCheckoutModeChanged: $options.onCheckoutModeChanged,
          onPaymentMethodChanged: $options.onPaymentMethodChanged
        }, null, 8 /* PROPS */, ["project-id", "is-modal-visible", "is-instant", "order-code", "provider-payment-id", "checkout-mode", "payment-data-source", "store-credit-card", "payment-type", "payment-action", "available-payment-methods", "onClose", "onCheckoutModeChanged", "onPaymentMethodChanged"]))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_progress_overlay, { visible: _ctx.isProcessing }, null, 8 /* PROPS */, ["visible"])
  ]))
}